import * as React from 'react';
import * as Colors from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { useActions } from '../../../hooks/useActions';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { HeartIcon } from '../../Icons/HeartIcon';
import { HeartFilledIcon } from '../../Icons/HeartFilledIcon';
import { eventTracker } from '../../../helpers/EventTracker/EventTracker';

interface IProps {
    cruiseNid: number;
}

const style: Record<string, React.CSSProperties> = {
    heartIconBlack: {
        color: Colors.softBlack,
        fill: Colors.softBlack,
        display: 'block',
        marginRight: 0,
    },
    heartIconRed: {
        color: Colors.softRed,
        fill: Colors.softRed,
        display: 'block',
    },
};

export const FavoriteToggle = (props: IProps) => {
    const { cruiseNid } = props;
    const { favoritePage } = useTypedSelector((state) => state);
    const isFavorite = favoritePage?.favorites.indexOf(cruiseNid) > -1;
    const { addToFavorites, removeFromFavorites } = useActions();
    const clickHandler = () => {
        if (isFavorite) {
            removeFromFavorites(cruiseNid, false);
            eventTracker.track({
                category: 'favorite',
                action: 'remove-from-favorite',
                label: '',
            });
        } else {
            addToFavorites(cruiseNid);
            eventTracker.track({
                category: 'favorite',
                action: 'add-to-favorite',
                label: '',
            });
        }
    };

    return (
        <button
            data-testid="btn-toggle-favorite"
            className="btn-favorite tooltip-icon"
            data-text={__('Add to Favourites list', 'dreamlines')}
            onClick={clickHandler}
        >
            <div className="vcenter action-icon">
                {isFavorite ? (
                    <HeartFilledIcon dropShadow={'none'} style={{ ...style.heartIconRed }} />
                ) : (
                    <HeartIcon dropShadow={'none'} style={{ ...style.heartIconBlack }} />
                )}
            </div>
            <span className="text-center vcenter">
                {isFavorite ? __('Saved', 'dreamlines') : __('Save', 'dreamlines')}
            </span>
        </button>
    );
};
